module.exports = __webpack_public_path__ + "img/banner-1.6435d91a.png";